var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderRequestSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6456_152072",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6456_152072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5V10.8327V10.8078V20.5V4.5ZM7.5 14H11.0963C11.1949 13.809 11.3013 13.6333 11.4155 13.473C11.5295 13.3128 11.6513 13.1552 11.7808 13H7.5V14ZM7.5 18H10.3865C10.3545 17.8333 10.3324 17.6667 10.3203 17.5C10.3081 17.3333 10.3058 17.1667 10.3135 17H7.5V18ZM5.6155 21.5C5.15517 21.5 4.77083 21.3458 4.4625 21.0375C4.15417 20.7292 4 20.3448 4 19.8845V5.1155C4 4.65517 4.15417 4.27083 4.4625 3.9625C4.77083 3.65417 5.15517 3.5 5.6155 3.5H13.5L18 8V11.0193C17.8372 10.9628 17.6724 10.9227 17.5057 10.899C17.3391 10.8753 17.1705 10.8533 17 10.8327V8.5H13V4.5H5.6155C5.4615 4.5 5.32042 4.56408 5.19225 4.69225C5.06408 4.82042 5 4.9615 5 5.1155V19.8845C5 20.0385 5.06408 20.1796 5.19225 20.3078C5.32042 20.4359 5.4615 20.5 5.6155 20.5H11.3905C11.516 20.6948 11.6557 20.8733 11.8095 21.0355C11.9635 21.1977 12.1251 21.3525 12.2942 21.5H5.6155ZM16.5 19.8078C17.2897 19.8078 17.9551 19.5372 18.4962 18.9962C19.0372 18.4551 19.3077 17.7897 19.3077 17C19.3077 16.2103 19.0372 15.5449 18.4962 15.0037C17.9551 14.4627 17.2897 14.1923 16.5 14.1923C15.7103 14.1923 15.0449 14.4627 14.5038 15.0037C13.9628 15.5449 13.6923 16.2103 13.6923 17C13.6923 17.7897 13.9628 18.4551 14.5038 18.9962C15.0449 19.5372 15.7103 19.8078 16.5 19.8078ZM21.6 22.7885L18.823 20.0115C18.4987 20.2705 18.1388 20.4679 17.7432 20.6038C17.3477 20.7397 16.9333 20.8078 16.5 20.8078C15.4423 20.8078 14.5433 20.4375 13.803 19.697C13.0625 18.9567 12.6923 18.0577 12.6923 17C12.6923 15.9423 13.0625 15.0433 13.803 14.303C14.5433 13.5625 15.4423 13.1923 16.5 13.1923C17.5577 13.1923 18.4567 13.5625 19.197 14.303C19.9375 15.0433 20.3078 15.9423 20.3078 17C20.3078 17.4333 20.2397 17.8477 20.1038 18.2432C19.9679 18.6388 19.7705 18.9987 19.5115 19.323L22.2885 22.1L21.6 22.7885Z",
    fill: "#111927"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderRequestSearchIcon);
export default __webpack_public_path__ + "static/media/order_request_search_icon.2331fb345fa4094b15a5c1a81084e166.svg";
export { ForwardRef as ReactComponent };